import { shouldShowSectionByDevice, shouldShowSectionByPageVariant } from '@helpers/sectionHelper';
import React from 'react';
import { useAtomValue } from 'jotai';
import { isMobileAtom } from '@atoms/appSettings';
import { usePageVariant } from '@contexts/PageVariantContext';
import { PageSection } from './PageSection';
import { Section } from '@models/section';

interface ConditionalPageSectionsProps {
    sections: Section[];
}

export function ConditionalPageSections({ sections }: ConditionalPageSectionsProps): React.ReactElement {
    const isMobile = useAtomValue(isMobileAtom);
    const { selectedPageVariant, pageVariants } = usePageVariant();

    return (
        <>
            {sections.map((section, index) => {
                const showSection =
                    shouldShowSectionByDevice(isMobile, section.jsonContent.deviceRestriction) &&
                    shouldShowSectionByPageVariant(selectedPageVariant, pageVariants, section);

                if (showSection) {
                    return <PageSection key={index} section={section} />;
                }

                return null;
            })}
        </>
    );
}
